import React from 'react';
import './styles.scss';
import Code from './assets/terminal';
import Scanface from './assets/scanface';
import Boxes from './assets/boxes';
import Escalationpolicy from './assets/escalationpolicy';
import Filecheck from './assets/filecheck';
import Scrolltext from './assets/scrolltext';
import Globe from './assets/globe';
import Email from './assets/email';

// style="padding-top: 40px; margin-top: -40px;"

const KeyFeatures = () => {
  return (
    <section className="keyfeatures enterprise">
      <h3 id="enterprise" className="font-weight-300 flex justify-content-center" style={{fontSize:'38px' }}>Enterprise-ready features</h3>
      <div className="keyfeatures-blocks mt-2em">
        <div>
          <span className="flex align-items-center gap-05em">
            <Scanface color="#fff" />
            <h4>Single Sign On</h4>
          </span>
            <p>Compatible with the most popular IdPs like Okta, Azure or Google.</p>
          {/* <a href="/docs">Documentation <img src={RightArrow} /></a> */}
        </div>
        
        <div>
          <span className="flex align-items-center gap-05em">
            <Code color="#fff" />
            <h4>REST API</h4>
          </span>
          <p>Use our REST API to integrate Hyperping seamlessly.</p>
        </div>

        <div>
          <span className="flex align-items-center gap-05em">
            <Scrolltext color="#fff" />
            <h4>Audit logging <small className="font-weight-400">(coming soon)</small></h4>
          </span>
            <p>Keep track of all user activity within your Hyperping Team.</p>
          {/* <a href="/docs">Documentation <img src={RightArrow} /></a> */}
        </div>
       
        <div>
          <span className="flex align-items-center gap-05em">
            <Email color="#fff" />
            <h4>Custom email address</h4>
          </span>
            <p>Send status page updates on your behalf.</p>
        </div>
      
        <div>
          <span className="flex align-items-center gap-05em">
            <Escalationpolicy color="#fff" />
            <h4>Escalation Policies</h4>
          </span>
            <p>Set rules on how alerts escalade during an incident.</p>
        </div>

        <div>
          <span className="flex align-items-center gap-05em">
            <Filecheck color="#fff" />
            <h4>GDPR compliant</h4>
          </span>
            <p>We are dedicated to complying, and assisting our customers in their efforts to comply to GDPR.</p>
          {/* <a href="/docs">Documentation <img src={RightArrow} /></a> */}
        </div>
        
        <div>
          <span className="flex align-items-center gap-05em">
            <Boxes color="#fff" />
            <h4>Multi-tenancy</h4>
          </span>
            <p>Host and manage unlimited status pages on behalf of your customers.</p>
          {/* <a href="/docs">Documentation <img src={RightArrow} /></a> */}
        </div>
      
        <div>
          <span className="flex align-items-center gap-05em">
            <Globe color="#fff" />
            <h4>Multilingual Status Pages</h4>
          </span>
            <p>Easily manage your status pages in multiple languages.</p>
          {/* <a href="/docs">Documentation <img src={RightArrow} /></a> */}
        </div>
        
      </div>
    </section>
  );
};

export default KeyFeatures;
